(() => {
  if (window.minismusNavigationReady) return;
  window.minismusNavigationReady = true;
  function sizeStickySlots(scope) {
    scope.querySelectorAll('.mn-header-nav-slot').forEach((slot) => {
      const header = slot.querySelector('.ltn__header-sticky');
      if (!header || slot.dataset.sized) return;
      slot.dataset.sized = 'true';
      const observer = new ResizeObserver(() => {
        const height = header.getBoundingClientRect().height;
        if (height) slot.style.setProperty('--mn-nav-height', height + 'px');
      });
      observer.observe(header);
      const cleanup = (event) => {
        if (!event.target.contains(slot)) return;
        observer.disconnect();
        document.removeEventListener('shopify:section:unload', cleanup);
      };
      document.addEventListener('shopify:section:unload', cleanup);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => sizeStickySlots(document));
  else sizeStickySlots(document);
  document.addEventListener('shopify:section:load', (event) => sizeStickySlots(event.target));
  document.addEventListener('toggle', (event) => {
    const details = event.target;
    if (!details.matches?.('.mn-nav__details') || !details.open) return;
    details.closest('[data-mn-nav]').querySelectorAll('.mn-nav__details[open]').forEach((other) => {
      if (other !== details) other.open = false;
    });
  }, true);
  document.addEventListener('click', (event) => {
    document.querySelectorAll('.mn-nav--desktop .mn-nav__details[open]').forEach((details) => {
      if (!details.contains(event.target)) details.open = false;
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const details = document.activeElement?.closest('.mn-nav__details[open]');
    if (details) {
      event.preventDefault();
      details.open = false;
      details.querySelector('summary').focus();
    } else {
      document.querySelectorAll('.mn-nav__details[open]').forEach((other) => { other.open = false; });
    }
  });
})();
